import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col text-left" }
const _hoisted_2 = {
  class: "font-bold text-lg text-textPrimary",
  "data-testid": "transition-modal-title"
}
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-[#68688D]"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-3 text-left text-sm",
  "data-testid": "transition-blocked-only"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "O que fazer:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("ol", { class: "list-decimal pl-5 flex flex-col gap-1" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Confirme com o financeiro se o Antecipe foi de fato pago."),
  /*#__PURE__*/_createElementVNode("li", null, "Se o médico realizou o plantão, mantenha-o alocado."),
  /*#__PURE__*/_createElementVNode("li", null, "Se não realizou, trate o estorno antes de mudar a cobertura.")
], -1)
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col gap-3 text-left text-sm"
}
const _hoisted_8 = {
  key: 0,
  "data-testid": "transition-single-sentence"
}
const _hoisted_9 = { class: "flex flex-col divide-y divide-gray-100 rounded-lg border border-solid border-lightGray30" }
const _hoisted_10 = {
  class: "flex justify-between gap-3 px-3 py-2",
  "data-testid": "transition-losing-doctor"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Plantões com médico que perdem o médico", -1)
const _hoisted_12 = {
  key: 0,
  class: "flex justify-between gap-3 px-3 py-2",
  "data-testid": "transition-notified"
}
const _hoisted_13 = {
  key: 1,
  class: "flex justify-between gap-3 px-3 py-2",
  "data-testid": "transition-activity-requests"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Cobranças de Registro de Atividade canceladas", -1)
const _hoisted_15 = {
  key: 2,
  class: "flex justify-between gap-3 px-3 py-2",
  "data-testid": "transition-post-station"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Avaliações pós-plantão marcadas como obsoletas", -1)
const _hoisted_17 = {
  key: 3,
  class: "flex justify-between gap-3 px-3 py-2",
  "data-testid": "transition-handover"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Convites de troca pendentes cancelados", -1)
const _hoisted_19 = {
  key: 4,
  class: "flex justify-between gap-3 px-3 py-2",
  "data-testid": "transition-open-to-unidentified"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Vagas abertas que passam a ocupadas", -1)
const _hoisted_21 = {
  key: 1,
  class: "rounded-md border border-solid border-alert bg-alert/10 px-3 py-2",
  "data-testid": "transition-blocked"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-[#68688D]" }, "Nada será pago a médicos por esses plantões. O valor-base fica só como referência.", -1)
const _hoisted_23 = { class: "flex flex-col-reverse md:flex-row gap-3 justify-end w-full p-4" }

import { computed } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { BLOCKED_REASON_LABELS } from '@/modules/company/Dashboard/modals/utils/coverageAllocation'
import type { CoverageTransitionSummary } from '@/modules/company/Dashboard/modals/utils/coverageAllocation'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageTransitionConfirmModal',
  props: {
    showModal: { type: Boolean },
    summary: {},
    contextLabel: { default: null },
    responsibleName: { default: null },
    loading: { type: Boolean, default: false }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit }) {

const props = __props;





const isBlockedOnly = computed(() => props.summary.total === 0 && props.summary.blocked.length > 0)
const hasAntecipeBlock = computed(() => props.summary.blocked.some((b) => b.reason === 'ANTECIPE'))
const notifiedCount = computed(() =>
  Math.max(props.summary.notifiedDoctorNames.length, props.summary.losingDoctorCount > 0 ? 1 : 0)
)

const title = computed(() => {
  if (isBlockedOnly.value) return 'Não é possível marcar sem identificação'
  const n = props.summary.total
  return n === 1
    ? 'Marcar 1 plantão como ocupado sem identificação?'
    : `Marcar ${n} plantões como ocupados sem identificação?`
})

const singleSentence = computed(() => {
  const name = props.summary.notifiedDoctorNames[0]
  if (props.summary.total !== 1 || props.summary.losingDoctorCount !== 1 || !name) return null
  const responsible = props.responsibleName || 'o responsável selecionado'
  return `O plantão deixa de ser de ${name} e passa a ser coberto por ${responsible}. ${name} será notificado de que foi removido.`
})

const blockedText = computed(() => {
  const list = props.summary.blocked
  const detail = list.map((b) => `${b.date}, com ${BLOCKED_REASON_LABELS[b.reason]}`).join('; ')
  const head = list.length === 1 ? '1 plantão bloqueado e ignorado' : `${list.length} plantões bloqueados e ignorados`
  const tail = hasAntecipeBlock.value
    ? ` Para ${list.length === 1 ? 'alterá-lo' : 'alterá-los'}, é preciso antes tratar o Antecipe com o financeiro.`
    : ''
  return `${head}: ${detail}.${tail}`
})

const blockedOnlyText = computed(() => {
  const first = props.summary.blocked[0]
  if (!first) return ''
  return `Este plantão tem ${BLOCKED_REASON_LABELS[first.reason]}.`
})

const formatOptional = (value: number | null) => (value === null ? 'se houver' : String(value))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    modalActive: _ctx.showModal,
    hasHeaderBorder: true,
    hasFooterBorder: true,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('cancel')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(title.value), 1),
        (_ctx.contextLabel)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.contextLabel), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(OutlineButton, {
          height: "48px",
          color: "grey",
          "data-testid": "transition-cancel-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(isBlockedOnly.value ? 'Entendi' : 'Voltar'), 1)
          ]),
          _: 1
        }),
        (!isBlockedOnly.value)
          ? (_openBlock(), _createBlock(FilledButton, {
              key: 0,
              height: "48px",
              color: "primary",
              loading: _ctx.loading,
              "data-testid": "transition-confirm-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Confirmar " + _toDisplayString(_ctx.summary.total) + " " + _toDisplayString(_ctx.summary.total === 1 ? 'plantão' : 'plantões'), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (isBlockedOnly.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(blockedOnlyText.value) + " Um plantão sem identificação nunca gera pagamento ao médico, então a troca não pode ser feita por aqui. ", 1),
            (hasAntecipeBlock.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_5,
                  _hoisted_6
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (singleSentence.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(singleSentence.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("b", null, _toDisplayString(_ctx.summary.losingDoctorCount), 1)
              ]),
              (notifiedCount.value > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                    _createElementVNode("span", null, [
                      _createTextVNode("Médicos notificados"),
                      (_ctx.summary.notifiedDoctorNames.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (" + _toDisplayString(_ctx.summary.notifiedDoctorNames.join(', ')) + ")", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("b", null, _toDisplayString(notifiedCount.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.summary.losingDoctorCount > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("b", null, _toDisplayString(formatOptional(_ctx.summary.canceledActivityRequests)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.summary.losingDoctorCount > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("b", null, _toDisplayString(formatOptional(_ctx.summary.obsoletedPostStationEvaluations)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.summary.losingDoctorCount > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("b", null, _toDisplayString(formatOptional(_ctx.summary.canceledHandoverInvites)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.summary.openBecomingUnidentified > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("b", null, _toDisplayString(_ctx.summary.openBecomingUnidentified), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.summary.blocked.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(blockedText.value), 1))
              : _createCommentVNode("", true),
            _hoisted_22
          ]))
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})